import React from 'react';
import * as H from 'history'

const MoveWithMarketo = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,history:H.History) => {
  e.preventDefault();

  // attr取得
  let url = e.currentTarget.getAttribute('href');
  let target = e.currentTarget.getAttribute('target');

  // hrefが空なら何もしない
  if( url === null){
    return;
  }

  // マルケト
  console.log(`[marketo_clickLink] url: ${e.currentTarget.href}`);
  (window as any).Munchkin.munchkinFunction('clickLink', {
    'href': url
  });

  // 外部ページを別ウィンドウで開くか、ページ遷移する
  if( target ){ // 別ウィンドウ
    window.open(url, 'win01', 'width=500,toolbar=yes,menubar=yes,scrollbars=yes');
  }else{ // ページ遷移
    history.push(url);
  }
}
export default MoveWithMarketo
